import client from '@util/api'
import { PatientModel, PatientUpdateModel } from '@context/UserContext/typing'
import { PATIENTS } from '../../../route.const'
import { PatientDetails } from '@patient/context/PatientProfileProvider/typing'

export const loadPatient = async () => {
  const response = await client.get<PatientModel>(`/${PATIENTS}`)
  localStorage.setItem('zip', response.data.location?.zip || '')
  return response.data
}

export const updatePatient = async (patient: PatientUpdateModel) => {
  const response = await client.patch<PatientModel>(`/${PATIENTS}`, patient)
  return response.data
}

export const loadPatientProfile = async () => {
  const response = await client.get<PatientDetails>(`/${PATIENTS}/profile/`)
  return response.data
}
